import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const DeleteIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M17 5V4a3 3 0 0 0-.92-2.08A3 3 0 0 0 14 1h-4a3 3 0 0 0-2.08.92A3 3 0 0 0 7 4v1H3a1 1 0 0 0 0 2h1v13a3 3 0 0 0 .92 2.08A3 3 0 0 0 7 23h10a3 3 0 0 0 2.08-.92A3 3 0 0 0 20 20V7h1a1 1 0 1 0 0-2h-4ZM9.33 3.33C9.1 3.57 9 3.83 9 4v1h6V4c0-.17-.1-.43-.33-.67-.24-.23-.5-.33-.67-.33h-4c-.17 0-.43.1-.67.33ZM6 7v13c0 .17.1.43.33.67.24.23.5.33.67.33h10c.17 0 .43-.1.67-.33.23-.24.33-.5.33-.67V7H6Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default DeleteIcon;
